// CORE (da inserire nel bundle principale)
import _scrollTo from "./_engine/_scrollto.controls.ts";

// FORMS
const forms = document.getElementsByTagName("form");
if (forms && forms.length > 0) {
    import("./_formValidation/_validation.bootstrapper.ts").then(({ default: _validationBootstrapper }) => {
        _validationBootstrapper.init(forms);
    });
    import("./_core/_floatLabels.ts").then(({ default: _floatLabels }) => {
        _floatLabels.init(document.querySelectorAll(".float-label"));
    });
}

// LIBRARIES
const swiper = document.querySelector(".swiper");
if (swiper) {
    import("./_engine/_swiper.controls.ts").then(({ default: _swiperControls }) => {
        _swiperControls.init();
    });
}

const lightbox = document.querySelector("[data-glightbox]");
if (lightbox) {
    // @ts-ignore
    import("glightbox/dist/css/glightbox.min.css");
    import("glightbox").then((module) => {
        const GLightbox = module.default;

        const lightbox = GLightbox({
            selector: "[data-glightbox]",
            zoomable: true,
            touchNavigation: true,
        });
    });
}

// BLOCKS
const accordions = document.querySelectorAll(".accordion-container");
if (accordions && accordions.length > 0) {
    import("./_blocks/_accordion.ts").then(({ default: _accordion }) => {
        _accordion.init(accordions);
    });
}

import("./_engine/_calculateHeight.controls.ts").then(({ default: _calculateHeight }) => {
    _calculateHeight.init();
});

// VARIE ED EVENTUALI

// Da attivare solo nel caso in cui nel sito sono presenti fasce
// che usano il pin dello scroll-trigger, assieme a fasce che cambiano di dimensione
const needsResizeChecker = false;
if (needsResizeChecker) {
    import("./_core/_resizeChecker.ts").then(({ default: _resizeChecker }) => {
        _resizeChecker.init();
    });
}

const audioGuidaList = document.querySelectorAll(".audio-guida");
if (audioGuidaList && audioGuidaList.length > 0) {
    import("./_elements/_audio.ts").then(({ default: _audio }) => {
        _audio.init(audioGuidaList);
    });
}

const modaleList = document.querySelectorAll(".modale-completamento");
if (modaleList && modaleList.length > 0) {
    import("./_engine/_modale.controls.ts").then(({ default: _modaleControls }) => {
        _modaleControls.init(modaleList);
    });
}

const qrcodeList = document.querySelectorAll(".qrcode");
if (qrcodeList && qrcodeList.length > 0) {
    import("./_engine/_qrcode.controls.ts").then(({ default: _qrcodeControls }) => {
        _qrcodeControls.init(qrcodeList);
    });
}

const shareList = document.querySelectorAll(".share");
if (shareList && shareList.length > 0) {
    import("./_engine/_share.controls.ts").then(({ default: _shareControls }) => {
        _shareControls.init(shareList);
    });
}

const readMoreList = document.querySelectorAll(".expandable");
if (readMoreList && readMoreList.length > 0) {
    import("./_engine/_readMore.controls.ts").then(({ default: _readMore }) => {
        _readMore.init(readMoreList);
    });
}
